/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
import React from "react"

import {Page} from "../constants/page/pages"
import {PagesArchitecture} from "../constants/page/pagesArchitecture"
import {SERVICE_BENEFICIARY_AREA, SERVIDOM_AREA} from "../shared-components/constants/areaTypes"
import {
    getChangePasswordErrorMessage,
    isFetchingChangePassword,
} from "../store/selectors/temporaries/changePasswordSelectors"
import {
    getResetPasswordDisplaySuccessMessage,
    getResetPasswordScore,
} from "../store/selectors/temporaries/resetPasswordSelectors"
import {navigateTo} from "../shared-components/services/navigate"

// ASYNC LAYOUTS
export const AsyncRoutingLayout = React.lazy(() => import("./routingLayout").catch(() => window.location.reload()))
export const AsyncDemandeLayout = React.lazy(() => import("./DemandeLayout").catch(() => window.location.reload()))

// ASYNC SCENES
const HomeScene = React.lazy(() => import("../scenes/Home/homeContainer").catch(() => window.location.reload()))

export const AsyncHomeScene = () => <HomeScene />

export const AsyncContactScene = React.lazy(() =>
    import("../scenes/Contact/contact").catch(() => window.location.reload()),
)

export const AsyncFAQScene = React.lazy(() => import("../scenes/FAQ/faq").catch(() => window.location.reload()))

export const AsyncAreaChoiceScene = React.lazy(() =>
    import("../scenes/AreaChoice/areaChoice").catch(() => window.location.reload()),
)

export const AsyncClientChoiceScene = React.lazy(() =>
    import("../scenes/ClientChoice/clientChoice").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeChoixDispositifScene = React.lazy(() =>
    import("../scenes/CreationDemandeChoixDispositif").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeNosPrestationsScene = React.lazy(() =>
    import("../scenes/CreationDemandeNosPrestations").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeInformationsComplementairesScene = React.lazy(() =>
    import("../scenes/CreationDemandeInformationsComplementaires").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeQuestionsAttributionScene = React.lazy(() =>
    import("../scenes/CreationDemandeQuestionsAttribution").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeChoixPrestationScene = React.lazy(() =>
    import("../scenes/CreationDemandeChoixPrestation").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeDetailsPrestationScene = React.lazy(() =>
    import("../scenes/CreationDemandeDetailsPrestation").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeInformationsPaiementScene = React.lazy(() =>
    import("../scenes/CreationDemandeInformationsPaiement").catch(() => window.location.reload()),
)

export const AsyncCreationDemandeConfirmationScene = React.lazy(() =>
    import("../scenes/CreationDemandeConfirmation").catch(() => window.location.reload()),
)

const UnauthorizedScene = React.lazy(() =>
    import("../shared-components/scenes/Unauthorized/unauthorizedContainer").catch(() => window.location.reload()),
)

export const AsyncUnauthorizedScene = () => (
    <UnauthorizedScene
        onHomeClick={() => navigateTo(PagesArchitecture[Page.HOME].route)}
        unauthorizedPage={Page.UNAUTHORIZED}
    />
)

const NotFoundScene = React.lazy(() => import("../scenes/NotFound/notFound").catch(() => window.location.reload()))

export const AsyncNotFoundScene = () => (
    <NotFoundScene notFoundPage={Page.NOT_FOUND} onHomeClick={() => navigateTo(PagesArchitecture[Page.HOME].route)} />
)

const TechnicalErrorScene = React.lazy(() =>
    import("../shared-components/components/ErrorBoundary/errorBoundary").catch(() => window.location.reload()),
)

export const AsyncTechnicalErrorScene = () => (
    <TechnicalErrorScene
        page={Page.TECHNICAL_ERROR}
        redirectToHomePage={() => navigateTo(PagesArchitecture[Page.HOME].route)}
    />
)

const LegalNoticeScene = React.lazy(() =>
    import("../shared-components/scenes/LegalNotice/legalNoticeContainer").catch(() => window.location.reload()),
)

export const AsyncLegalNoticeScene = () => (
    <LegalNoticeScene
        areaType={SERVIDOM_AREA}
        legalNoticePage={Page.LEGAL_NOTICE}
        redirectToLoginPage={() => navigateTo(PagesArchitecture[Page.HOME].route)}
        withCGS={false}
    />
)

const DeclarationAccessibiliteEbuScene = React.lazy(() =>
    import("../shared-components/scenes/DeclarationAccessibiliteEBU").catch(() => window.location.reload()),
)
export const AsyncDeclarationAccessibiliteEbuScene = () => (
    <DeclarationAccessibiliteEbuScene
        page={Page.DECLARATION_ACCESSIBILITE}
        redirectToLoginPage={() => navigateTo(PagesArchitecture[Page.HOME].route)}
    />
)

export const AsyncRegistrationProfileScene = React.lazy(() =>
    import("../scenes/RegistrationProfile/registrationProfile").catch(() => window.location.reload()),
)

export const AsyncRegistrationPasswordScene = React.lazy(() =>
    import("../scenes/RegistrationPassword/registrationPassword").catch(() => window.location.reload()),
)

export const AsyncForgottenLoginOrPasswordScene = React.lazy(() =>
    import("../scenes/ForgottenLoginOrPassword/forgottenLoginOrPassword").catch(() => window.location.reload()),
)

export const AsyncProfileScene = React.lazy(() =>
    import("../scenes/Profile/profile").catch(() => window.location.reload()),
)

export const AsyncProfileRelativeAddOrEditScene = React.lazy(() =>
    import("../scenes/Profile/ProfileRelatives/profileRelativesAddOrEdit").catch(() => window.location.reload()),
)

// TODO _ rename -> Historique demandes
export const AsyncCommandeScene = React.lazy(() =>
    import("../scenes/Commande/commandeScene").catch(() => window.location.reload()),
)

export const AsyncVisualisationModificationDemandeScene = React.lazy(() =>
    import("../scenes/VisualisationModificationDemande").catch(() => window.location.reload()),
)

export const AsyncResilierCommandeScene = React.lazy(() =>
    import("../scenes/Commande/commandeResiliationRecurrenceScene").catch(() => window.location.reload()),
)

export const AsyncFacturesScene = React.lazy(() =>
    import("../scenes/Factures/index").catch(() => window.location.reload()),
)

export const AsyncPaiementFacturesScene = React.lazy(() =>
    import("../scenes/PaiementFactures").catch(() => window.location.reload()),
)

export const AsyncAiciFonctionnementScene = React.lazy(() =>
    import("../scenes/AiciFonctionnement").catch(() => window.location.reload()),
)

export const AsyncAiciInscriptionScene = React.lazy(() =>
    import("../scenes/AiciInscription").catch(() => window.location.reload()),
)

export const AsyncAiciValidationScene = React.lazy(() =>
    import("../scenes/AiciValidation").catch(() => window.location.reload()),
)

export const AsyncAiciTransmissionScene = React.lazy(() =>
    import("../scenes/AiciTransmission").catch(() => window.location.reload()),
)

const StyleGuideScene = React.lazy(() =>
    import("../shared-components/scenes/StyleGuide/styleGuide").catch(() => window.location.reload()),
)

export const AsyncStyleGuideScene = () => <StyleGuideScene />

const ResetPasswordScene = React.lazy(() =>
    import("../scenes/ResetPassword/resetPassword").catch(() => window.location.reload()),
)

export const AsyncResetPasswordScene = () => (
    <ResetPasswordScene
        areaType={SERVICE_BENEFICIARY_AREA}
        errorMessage={getChangePasswordErrorMessage}
        getResetPasswordDisplaySuccessMessage={getResetPasswordDisplaySuccessMessage}
        getResetPasswordScore={getResetPasswordScore}
        isFetching={isFetchingChangePassword}
        loginRoute={PagesArchitecture[Page.LOGIN].route}
        resetPasswordPage={Page.RESET_PASSWORD}
    />
)
